import { render, staticRenderFns } from "./ChangeState.vue?vue&type=template&id=72aef834&"
import script from "./ChangeState.vue?vue&type=script&lang=js&"
export * from "./ChangeState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports